import { styled } from '@mui/material/styles'
import React from 'react'
import { BooleanInput, SelectInput } from 'react-admin'
import { PricingRule } from 'services/api/entities/catalog/types'
import { pricingRulesTypeChoices } from 'services/cfg/form'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import KToolTip from 'ui-shared/KTooltip'

const PREFIX = 'PricingRuleThenClauseInputGroup'

const classes = {
  container: `${PREFIX}-container`,
  pricingContainer: `${PREFIX}-pricingContainer`,
  type: `${PREFIX}-type`,
  modifiers: `${PREFIX}-modifiers`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  divider: `${PREFIX}-divider`,
  marginBottom: `${PREFIX}-marginBottom`,
  flex: `${PREFIX}-flex`,
  w100: `${PREFIX}-w100`,
  marginRight: `${PREFIX}-marginRight`,
  marginTop: `${PREFIX}-marginTop`,
  fieldsBox: `${PREFIX}-fieldsBox`,
  fieldWidth: `${PREFIX}-fieldWidth`,
  halfFieldWidth: `${PREFIX}-halfFieldWidth`,
  ml55: `${PREFIX}-ml55`,
  clauseText: `${PREFIX}-clauseText`,
}

const StyledDiv = styled('div')(({ theme }: any) => ({
  [`& .${classes.container}`]: {
    marginTop: '24px',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.pricingContainer}`]: {
    width: '100%',
    marginTop: '24px',
    display: 'flex',
    gap: '400px',
  },

  [`& .${classes.type}`]: {
    minWidth: '100px',
  },

  [`& .${classes.modifiers}`]: {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.sectionTitle}`]: {
    fontWeight: 'bold',
    fontSize: '20px',
    marginTop: '24px',
    textTransform: 'capitalize',
  },

  [`& .${classes.divider}`]: {
    width: '100%',
    height: '3px',
    backgroundColor: theme.palette.primary.light,
    marginTop: '20px',
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: '16px',
  },

  [`& .${classes.flex}`]: {
    display: 'flex',
  },

  [`& .${classes.w100}`]: {
    width: '100%',
  },

  [`& .${classes.marginRight}`]: {
    marginRight: '16px',
  },

  [`& .${classes.marginTop}`]: {
    marginTop: '16px',
  },

  [`&.${classes.fieldsBox}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '100px',
    width: '100%',
  },

  [`& .${classes.fieldWidth}`]: {
    width: '300px',
  },

  [`& .${classes.halfFieldWidth}`]: {
    width: '150px',
  },

  [`& .${classes.ml55}`]: {
    marginLeft: '50px',
  },

  [`& .${classes.clauseText}`]: {
    fontSize: '20px',
    fontWeight: 'bold',
    width: '10px',
    marginBottom: '20px',
  },
}))

type Props = ArrayInputContentProps

const PricingRuleThenClauseInputGroup: React.FC<Props> = ({ source }) => {
  const { kGetSource } = useKArrayInput<PricingRule>(source!)

  return (
    <StyledDiv className={classes.fieldsBox}>
      <span className={classes.clauseText}>THEN</span>
      <SelectInput
        source={kGetSource('priceType')}
        label="Price type"
        defaultValue={pricingRulesTypeChoices[0].id}
        choices={pricingRulesTypeChoices}
        className={classes.fieldWidth}
      />
      <KToolTip title="tooltip.pricingRule.isExtra" placement="top">
        <BooleanInput
          source={kGetSource('isExtra')}
          label="form.fields.isExtra"
        />
      </KToolTip>
    </StyledDiv>
  )
}

export default PricingRuleThenClauseInputGroup
